"use client";

import { BSRAdd } from "./bsr/BSRAdd";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Add as LegacyAdd } from "./legacy/Add";

export const Add = createBSRExperimentIcon(LegacyAdd, BSRAdd);
